import { Icon } from "@blueprintjs/core";
import { DataDisplayRecord } from "components/data-display";
import { Tooltip } from "components/tooltip";
import PropTypes from "prop-types";
import React from "react";

import "./GreyFleetShared.css";

const defaultArray = [];

// Renders the cover declared on an insurance policy. Records carrying declared cover types show
// their names with a tooltip describing each, flagged by an info icon beside the header so the
// tooltip is discoverable; records that only answered the single business use question show that
// answer under a fixed "Business Use" header instead. Declared ids with no entry in the lookup are
// not shown, and a record left with neither resolved cover types nor a business use answer shows a
// dash.
export function TypesOfCoverRecord(
    {
        loading,
        header = "Type of Cover",
        coverTypeIds = defaultArray,
        coverTypes = defaultArray,
        legacyBusinessUse = null
    }
) {
    const declaredCoverTypes = coverTypeIds
        .map((coverTypeId) => coverTypes.find((coverType) => coverType.id === coverTypeId))
        .filter((coverType) => coverType != null);

    let coverRecord;

    if (loading) {
        coverRecord = <DataDisplayRecord header={header} loading={loading} />;
    }
    else if (declaredCoverTypes.length > 0) {
        const coverTypeDescriptions = (
            <ul>
                {declaredCoverTypes.map((coverType) => (
                    <li key={`cover-type-description-${coverType.id}`}>
                        <strong>{coverType.name}</strong>
                        <div>{coverType.description}</div>
                    </li>
                ))}
            </ul>
        );

        coverRecord = (
            <Tooltip content={coverTypeDescriptions}>
                <DataDisplayRecord
                    header={
                        <span className="types-of-cover-header">
                            {header}
                            <Icon icon="info-sign" size={12} />
                        </span>
                    }
                    data={declaredCoverTypes.map((coverType) => <div key={`cover-type-${coverType.id}`}>{coverType.name}</div>)}
                />
            </Tooltip>
        );
    }
    else if (legacyBusinessUse != null) {
        coverRecord = <DataDisplayRecord header="Business Use" data={legacyBusinessUse ? "Yes" : "No"} />;
    }
    else {
        coverRecord = <DataDisplayRecord header={header} data="-" />;
    }

    return coverRecord;
}

TypesOfCoverRecord.propTypes = {
    loading: PropTypes.bool.isRequired,
    header: PropTypes.node,
    coverTypeIds: PropTypes.array,
    coverTypes: PropTypes.array,
    legacyBusinessUse: PropTypes.bool
};
